import React from 'react'
import CV from './CV'
import ImageGrid from './ImageGrid'
import ProfileInfo from './ProfileInfo'
import { Language, Agents, Button } from './ProfileInfo'
// import { videoImage } from './Video'
// import profile from './data'

import './pdf_profile.scss'
// import { Tabs, Tab } from 'react-blazecss'

import { nameOf } from './utils'

const host = REST_API// "http://localhost:8080"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
const baseUrl = host + "/api/files"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"


import { FlipBox } from '../components/FlipBox'

class Profile2Info extends React.Component {
  render(){
    const { profile } = this.props
    const { categories=[], videos=[], portfolio=[] } = profile 
    const isPDF = true
    return (
      <div>
        <div style={{display: 'table', width: '100%'}}>
          <div style={{display: 'table-cell', width: '60%', paddingRight: 8, verticalAlign: 'top'}}>
            <h1>{nameOf(profile)}</h1>
            <h2>{categories.map(cat => cat.label).join(", ")}</h2>

            <div className="profile-info__column" style={{fontWeight: 300, fontSize: '1.0em'}}>
              <h3>Langues</h3>
              <div>
                {profile.languages.map(l => <Language key={l.lang.value} lang={l.lang.value} label={l.lang.label} level={l.level} />)}
              </div>
              <div dangerouslySetInnerHTML={{__html: profile.description}} />
            </div>
          </div>
          <div style={{display: 'table-cell', width: '40%', verticalAlign: 'top'}}>
            <Agents agents={profile.agents} isPDF={true} />
            {profile.videos && profile.videos.length > 0 && (
              <a href={videos[0].url} target="__blank" style={{marginTop: 8, width: '100%', cursor: 'pointer',
              display: 'block',
              border: '1px solid #034f84', color: '#034f84', textAlign: 'center', padding: 8, borderRadius: 3}}>
                Voir la vidéo
              </a>
            )}
          </div>
        </div>
      </div>
    )
  }
}



class ProfileLeft extends React.Component {

  render(){
    const { profile } = this.props
    console.log("profile", profile)
    const imageId = profile.profileImage
    const profileImage = imageId && (baseUrl + "/" + imageId.id + "/thumbnail?w=200&h=320&auto")
    const images = profile.portfolio || []
    return (
      <div>
        <img src={profileImage} 
             className="img-responsive wp-image-1776"
             style={{ cursor: 'pointer', width: '100%' }} />
        <div style={{paddingTop: 8}}>
          <ImageGrid images={images.slice(0, 8)} gridSize={2}/>
        </div>
      </div>
    )
  }
}

function makeEntry(title, items, key){
  if (!items || items.length == 0) return null
  const entry = {
    date: title,
    title: items.map(i => i[key] && i[key].label).filter(i => i).join(", ")
  }
  return entry.title.length > 0 ? entry : null // Can have filtered out null entries
}

function heightFormatter(num) {
    return (num/100).toFixed(2).replace('.', 'm')
}

function buildCV(profile){
  const baseCV = profile.cv || [];
  const extraEntry = {
    title: "Divers",
    entries: [
      profile.permis && {date: "Permis", title: profile.permis},
      // profile.height && {date: "Taille", title: heightFormatter(profile.height)},
      // makeEntry("Sports", profile.sports, "sport"),
      // makeEntry("Musique", profile.instruments, "instrument"),
    ].filter(e => e)
  }
  if (extraEntry.entries.length > 0){
    return [
      ...baseCV,
      extraEntry
    ]
  } else {
    return baseCV
  }
}

export class PDFProfile extends React.Component {
  render() {
    const { profile } = this.props
    return (
      <div className="pdf_profile post-content" style={{fontFamily: "sans-serif"}}>
        <div style={{width: '100%', textAlign: 'center'}}>
          <img className="header-logo" src="//www.cyrillejoubert-talents.com/wp-content/uploads/2016/07/Logo_Cyrille_Joubert.png" alt="Cyrille Joubert Talents" />
        </div>
        <div style={{ backgroundColor: 'rgba(255,255,255,0)', display: 'table', width: '100%'}}>
          <div style={{width: '25%', display: 'table-cell', verticalAlign: 'top', padding: 8}}>
            <ProfileLeft profile={profile} />
          </div>
          <div style={{width: '75%', display: 'table-cell', verticalAlign: 'top', padding: 8}}>
            <div style={{textAlign: 'left'}}>
              <Profile2Info profile={profile} />
              <div className="pdf_title">
                <div className="pdf_title__cell">
                  <div className="pdf_title__cell__double-line"> </div>
                </div>
                <div style={{display: 'table-cell', width: 80, padding: '0 45px'}}>
                  <h2 style={{textAlign: 'center'}}>CV</h2>
                </div>
                <div className="pdf_title__cell">
                  <div className="pdf_title__cell__double-line"> </div>
                </div>
              </div>
              <div style={{fontSize: '0.8em'}}>
                <CV data={buildCV(profile)} width="100%" showDate={profile.showDate}/>
              </div>
            </div>
          </div>
        </div>   
        <div id="pageHeader" style={{height: 8}}>
        </div>
        <div id="pageFooter" 
             style={{fontFamily: 'sans-serif', fontSize: 14, display: 'table', width: '100%', paddingTop: 8, textAlign: 'center', verticalAlign: 'middle'}}>
          <div style={{display: 'table-cell', width: '36%', textAlign: 'left', fontWeight: 'bold', verticalAlign: 'middle', padding: '0 0 0 28px'}}>
            Agence artistique<br />Cyrille Joubert Talents
          </div>
          <div style={{display: 'table-cell', width: '28%', textAlign: 'center', verticalAlign: 'middle', padding: '0'}}>121, Rue d’Aguesseau<br />92100 Boulogne Billancourt</div>
          <div style={{display: 'table-cell', width: '36%', textAlign: 'right', verticalAlign: 'middle', padding: '0 28px 0 0'}}>
            06.62.63.47.24<br />
            <a style={{color: '#034f84', textDecoration: 'none'}} href="https://www.cyrillejoubert-talents.com">cyrillejoubert-talents.com</a>
          </div>
        </div> 
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/profile/PDFProfile.js
 **/